import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { userAtom } from '../state/atoms/authAtoms';
import { getStabilityPresentation } from '../services/ShootingData/service';
import { toStabilityPresentation } from '../adapters/stabilityPresentationAdapter';
import { StabilityPresentation } from '../types/ui/weaponPresentation';
import { RawStabilityPresentation } from '../types/api/drill';


export function useStabilityPresentation(
  sessionId: number,
  scenarioId: number,
  drillName: string,
  repetitionNumber?: number
): UseQueryResult<StabilityPresentation, Error> {
  const userId = useAtomValue(userAtom)!.user_id;

  return useQuery<
    RawStabilityPresentation,
    Error,
    StabilityPresentation
  >({
    queryKey: [
      'stabilityPresentation',
      userId,
      sessionId,
      scenarioId,
      drillName,
      repetitionNumber,
    ],
    queryFn: () =>
      getStabilityPresentation(
        userId,
        sessionId,
        scenarioId,
        drillName,
        repetitionNumber
      ),
    select: toStabilityPresentation,
    enabled:
      Boolean(userId) &&
      Boolean(sessionId) &&
      Boolean(scenarioId) &&
      Boolean(drillName),
    staleTime: 5 * 60_000,
  });
}
